export default function iconBoxWidget(editor) {
  editor.DomComponents.addType('eb-icon-box', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-icon-box'
    },
    model: {
      defaults: {
        name: 'Icon Box',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-icon-box' },
        style: {
          'text-align': 'center',
          'padding': '30px 20px',
        },
        components: `
          <div style="font-size:48px;color:#667eea;margin-bottom:15px;"><i class="fa fa-cog"></i></div>
          <h4 style="font-size:20px;font-weight:600;color:#333;margin:0 0 10px;">Feature Title</h4>
          <p style="font-size:14px;color:#666;line-height:1.6;margin:0;">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper.</p>
        `,
        traits: [
          { type: 'text', name: 'data-icon-class', label: 'Icon Class', changeProp: true },
        ],
      },
    },
  })

  editor.BlockManager.add('eb-icon-box', {
    label: 'Icon Box',
    category: 'General',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M12,16.5C11,16.5 10,16.6 9.2,17H14.8C14,16.6 13,16.5 12,16.5Z"/></svg>',
    content: { type: 'eb-icon-box' },
  })
}
